import freightTariff from './freight-tariff'
import car from './car'
import addon from './addon'

export default {
  name: 'FinancialFreightTariff',
  path: 'freight',
  meta: {
    label: 'freight',
    auth: 'freight'
  },
  component: {
    name: 'Freight',
    render(c) {
      return c('router-view')
    }
  },
  children: [freightTariff, car, addon]
}
